import { AssetTypes } from './enums/AssetTypes';

export function getAssetUrl(
    asset: { type?: string | undefined; id: string; isPanorama?: boolean | undefined },
    options: {
        forceDownload?: boolean;
        objectId?: string | undefined;
        surveyId?: string | undefined;
        equipmentId?: string | undefined;
        useThumbnail?: boolean | undefined;
    },
): string {
    if (options.forceDownload) {
        if (options.objectId) {
            return `/api/objects/${options.objectId}/assets/${asset.id}/download?forceDownload=true`;
        }
        if (options.equipmentId) {
            return `/api/equipmentAsset/${asset.id}/download?forceDownload=true`;
        }
        return `/api/assets/${asset.id}/download?forceDownload=true`;
    } else if (asset.type === AssetTypes.Image360 || (asset.isPanorama && asset.type === AssetTypes.DerivedImage)) {
        return `/panorama.html?assetid=${asset.id}`;
    } else if (asset.type === AssetTypes.DerivedVideo) {
        return asset.isPanorama ? `/player.html?assetid=${asset.id}&panorama=true` : `/player.html?assetid=${asset.id}`;
    } else if (
        asset.type === AssetTypes.ImageAnnotation &&
        ((options.surveyId && options.surveyId !== 'undefined') || (options.objectId && options.objectId !== 'undefined'))
    ) {
        return `/annotation.html?assetid=${asset.id}&objectid=${options.objectId}&surveyid=${options.surveyId}`;
    }
    if (options.useThumbnail) {
        if (asset.type === AssetTypes.MeasurementXLS) {
            return '/assets/img/excel_thmb.png';
        }
        if (asset.type === AssetTypes.MeasurementPDF) {
            return '/assets/img/pdf_thmb.png';
        }
        if (options.equipmentId) {
            return `/api/equipmentAsset/${asset.id}/download?thumb=true`;
        }
        return `/api/assets/${asset.id}/download?thumb=true`;
    }
    if (options.equipmentId) {
        return `/api/equipmentAsset/${asset.id}/download`;
    }
    return `/api/assets/${asset.id}/download`;
}
